import { Icon } from "@iconify/react";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A component shows multiple steps of a process, and indicates to the user which step they are on
 *
 * @param {Object} props
 * @param {{id: number, text: string}[]} props.steps - A list of the steps given. Each step should have an id and a text
 * @param {number} props.subTab - The current selected step id
 * @param {string} props.className - The className of the container
 * @returns {JSX.Element}
 */

const Stepper = ({ steps, subTab, className }) => {
  const activeStepIndex = steps.findIndex((step) => step.id === subTab);
  const stepWidth = `${100 / steps.length}%`;
  const {
    i18n: { language },
  } = useTranslation("global");

  return (
    <ol className={className} style={{ borderColor: "lightgray" }}>
      {steps.map((step, index) => (
        <li
          key={step.text}
          className={`flex items-center ${
            index === activeStepIndex ? "text-blue-600" : "text-gray-500"
          } ${index === steps.length - 1 ? "justify-end" : "justify-start"}`}
          style={{ width: stepWidth }}
        >
          <div className="flex flex-row items-center pr-2">
            <span
              className={clsx(
                "flex items-center justify-center w-5 h-5 me-2 text-xs rounded-full shrink-0",
                index <= activeStepIndex
                  ? "bg-background_steel_blue text-text_white"
                  : "bg-background_grey text-gray-500"
              )}
            >
              {index + 1}
            </span>
            <span
              className={clsx(
                "font-bold md:mt-0 text-sm md:text-base",
                index <= activeStepIndex
                  ? "text-background_steel_blue"
                  : "text-text_black"
              )}
            >
              {step.text}
            </span>
          </div>
          {index < steps.length - 1 && (
            <Icon
              icon={`${
                language === "ar"
                  ? "iconamoon:arrow-left-2-light"
                  : "iconamoon:arrow-right-2-light"
              }`}
              width="28px"
              height="28px"
              style={{ color: "#787878" }}
            />
          )}
        </li>
      ))}
    </ol>
  );
};

export default Stepper;
